import { render, staticRenderFns } from "./AuditsSettings.vue?vue&type=template&id=316a369c&scoped=true&"
import script from "./AuditsSettings.vue?vue&type=script&lang=js&"
export * from "./AuditsSettings.vue?vue&type=script&lang=js&"
import style0 from "./AuditsSettings.vue?vue&type=style&index=0&id=316a369c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a369c",
  null
  
)

export default component.exports